import { globalizeSelectors } from '../Utils';
import {
  clearResults,
  createSingleDataReducer,
  singleDataType,
} from '../factories/ApiCall';
import PropTypes from 'prop-types';
import { combineReducers } from 'redux';
import type {
  EmailAction,
  EmailMessageResponse,
  EmailState,
  SendEmailParameters,
} from '../types/Email';
/**
 * Just a simple flag to notify the UI that progress modal needs to be shown!
 */

/*
 * action types
 */

const types = {
  SEND_EMAIL: 'EMAIL/SEND_EMAIL',
} as const;

/*
 * action creators
 */

const actions = {
  sendEmail: (
    subject: string,
    html: string,
    recievers: string
  ): EmailAction<SendEmailParameters> => ({
    type: types.SEND_EMAIL,
    payload: { subject, html, recievers },
  }),
  clear: (): EmailAction => ({
    type: clearResults(types.SEND_EMAIL),
  }),
};

const mountPath = 'email'; // mount point in global state, must match root reducer

/*
 * state shape
 */
const propType = PropTypes.shape({
  send_mail: singleDataType,
});

/*
 * reducer
 */
const reducer = combineReducers({
  send_mail: createSingleDataReducer<EmailMessageResponse, SendEmailParameters>(
    types.SEND_EMAIL
  ),
}) as (state: EmailState | undefined, action: EmailAction) => EmailState;

/*
 * selectors
 */
const localSelectors = {
  send_mail: (state: EmailState): EmailState['send_mail'] => state.send_mail,
};

const selectors = globalizeSelectors(localSelectors, mountPath);

export {
  types as actionTypes,
  actions as default,
  propType,
  selectors,
  reducer,
};
